// Helper function to get current discount percentage
function getDiscountPercentage() {
  const discountContainer = document.querySelector('.product-main__active-discount-container') || 
                           document.querySelector('.variant__active-discount-container') ||
                           document.querySelector('.product-card__active-discount-container')
  let discountPercentage = 0
  
  if (discountContainer) {
    const discountText = discountContainer.textContent.trim()
    discountPercentage = parseFloat(discountText.replace('%', ''))
  }
  
  // Fallback to window.dates if available
  if (!discountPercentage && window.dates && window.dates.discount_percentage) {
    discountPercentage = parseFloat(window.dates.discount_percentage)
  }
  
  return discountPercentage
}

// Helper function to check if discount is currently active
function isDiscountActive() {
  if (!window.dates || !window.dates.discount_enabled) {
    return false
  }
  
  // Check if discount elements exist (they might not be visible yet for single variants)
  const discountedPriceElement = document.querySelector('.product__price--discounted')
  if (!discountedPriceElement) {
    return false
  }
  
  // For the initial check, we also consider it active if the element exists but is hidden
  // (since we haven't processed it yet for single variants)
  return true
}

// Make helper functions available globally for other scripts
window.pahlowmediaDiscountHelpers = {
  getDiscountPercentage,
  isDiscountActive
}

// Function to recalculate discount for a specific variant (used by variant selection)
function recalculateVariantDiscount(variant) {
  const discountPercentage = getDiscountPercentage()
  
  // Check if this is a main product variant or product card variant
  const isMainProductVariant = variant.classList.contains('variant__container')
  const isProductCardVariant = variant.classList.contains('product-card__variant')
  
  let rawPrice = 0
  if (isMainProductVariant) {
    rawPrice = parseFloat(variant.getAttribute('data-variant-original-price'))
  } else if (isProductCardVariant) {
    rawPrice = parseFloat(variant.getAttribute('data-variant-price-raw'))
  }
  
  if (isDiscountActive() && discountPercentage > 0 && rawPrice) {
    const discountedPrice = rawPrice * (1 - discountPercentage / 100)
    const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format(discountedPrice / 100)
    
    variant.setAttribute('data-variant-price-discounted', formattedDiscountedPrice)
    return formattedDiscountedPrice
  }
  
  return null
}

// Make recalculate function available globally
window.pahlowmediaDiscountHelpers.recalculateVariantDiscount = recalculateVariantDiscount

const productCardActiveDiscount = document.querySelectorAll(".product-card__active-discount-container")
const productCardActiveDiscountPrice = document.querySelectorAll(".product-card__price--discounted")

// Main product elements
const productMainActiveDiscount = document.querySelectorAll(".product-main__active-discount-container")
const productMainDiscountedPrice = document.querySelectorAll(".product__price--discounted")
const variantActiveDiscounts = document.querySelectorAll(".variant__active-discount-container")

if(window.dates && window.dates.discount_enabled){
  const now = new Date()
const startDate = new Date(window.dates.date_start)
const endDate = new Date(window.dates.date_end)

if (now >= startDate && now <= endDate) {
    productCardActiveDiscount.forEach((item)=>{
      item.style.display = "block"
    })

    // Show main product discount badges
    productMainActiveDiscount.forEach((item)=>{
      item.style.display = "block"
    })

    variantActiveDiscounts.forEach((item)=>{
      item.style.display = "block"
    })

    productCardActiveDiscountPrice.forEach((item)=>{
      const originalPrice = parseFloat(item.getAttribute("data-original-price"))
      
      // Get discount percentage from the discount container text
      const discountContainer = document.querySelector('.product-card__active-discount-container')
      let discountPercentage = 0
      
      if (discountContainer) {
        const discountText = discountContainer.textContent.trim()
        discountPercentage = parseFloat(discountText.replace('%', ''))
      }
      
      // Fallback to window.dates if available
      if (!discountPercentage && window.dates && window.dates.discount_percentage) {
        discountPercentage = parseFloat(window.dates.discount_percentage)
      }
      
      if (isNaN(originalPrice) || isNaN(discountPercentage) || discountPercentage <= 0) {
        console.error('Invalid price or discount percentage:', {originalPrice, discountPercentage})
        return
      }
      
      const discountedPrice = originalPrice * (1 - discountPercentage / 100)
      
      // Format the discounted price as currency
      const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: 'CHF'
      }).format(discountedPrice / 100) // Shopify prices are in cents
      
      // Display the discounted price
      item.textContent = formattedDiscountedPrice
      item.style.display = 'inline'
      
      // Mark the regular price as having an active discount
      const regularPrice = item.parentElement.querySelector('.product-card__price--regular')
      if (regularPrice) {
        regularPrice.classList.add('discount-active')
      }
      
      // Hide the regular compare price when discount is active
      const regularComparePrice = item.parentElement.querySelector('.product-card__compare-price--regular')
      if (regularComparePrice) {
        regularComparePrice.classList.add('discount-active')
      }
    })

    // Handle main product discounted prices
    productMainDiscountedPrice.forEach((discountedPriceEl) => {
      const originalPrice = parseFloat(discountedPriceEl.getAttribute("data-original-price"))
      
      // Get discount percentage from the discount container text
      const discountContainer = document.querySelector('.product-main__active-discount-container') || document.querySelector('.product-card__active-discount-container')
      let discountPercentage = 0
      
      if (discountContainer) {
        const discountText = discountContainer.textContent.trim()
        discountPercentage = parseFloat(discountText.replace('%', ''))
      }
      
      // Fallback to window.dates if available
      if (!discountPercentage && window.dates && window.dates.discount_percentage) {
        discountPercentage = parseFloat(window.dates.discount_percentage)
      }
      
      if (isNaN(originalPrice) || isNaN(discountPercentage) || discountPercentage <= 0) {
        console.error('Invalid price or discount percentage:', {originalPrice, discountPercentage})
        return
      }
      
      const discountedPrice = originalPrice * (1 - discountPercentage / 100)
      
      // Format the discounted price as currency
      const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: 'CHF'
      }).format(discountedPrice / 100) // Shopify prices are in cents
      
      // Display the discounted price
      discountedPriceEl.textContent = formattedDiscountedPrice
      discountedPriceEl.style.display = 'inline'
      
      // Mark the regular price as having an active discount
      const regularPrice = discountedPriceEl.parentElement.querySelector('.product__price--regular')
      if (regularPrice) {
        regularPrice.classList.add('discount-active')
      }
      
      // Hide the regular compare price when discount is active
      const regularComparePrice = discountedPriceEl.parentElement.querySelector('.product__compare-at-price--regular')
      if (regularComparePrice) {
        regularComparePrice.classList.add('discount-active')
      }
    })
    
    // Also calculate discount for all variants and store as data attributes
    // Handle both main product variants and product card variants
    const mainProductVariants = document.querySelectorAll('.variant__container')
    const productCardVariants = document.querySelectorAll('.product-card__variant')
    
    // Get discount percentage from the discount container text
    const discountContainer = document.querySelector('.product-main__active-discount-container') || 
                             document.querySelector('.variant__active-discount-container') ||
                             document.querySelector('.product-card__active-discount-container')
    let discountPercentage = 0
    
    if (discountContainer) {
      const discountText = discountContainer.textContent.trim()
      discountPercentage = parseFloat(discountText.replace('%', ''))
    }
    
    // Fallback to window.dates if available
    if (!discountPercentage && window.dates && window.dates.discount_percentage) {
      discountPercentage = parseFloat(window.dates.discount_percentage)
    }

    // Process main product variants
    mainProductVariants.forEach((variant) => {
      const rawPrice = parseFloat(variant.getAttribute('data-variant-original-price'))
      const rawComparePrice = parseFloat(variant.getAttribute('data-variant-compare-price'))

      if (rawPrice && !isNaN(discountPercentage) && discountPercentage > 0) {
        const discountedPrice = rawPrice * (1 - discountPercentage / 100)
        const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: 'CHF'
        }).format(discountedPrice / 100)
        
        variant.setAttribute('data-variant-price-discounted', formattedDiscountedPrice)
      }
      
      if (rawComparePrice && rawComparePrice > 0 && !isNaN(discountPercentage) && discountPercentage > 0) {
        const discountedComparePrice = rawComparePrice * (1 - discountPercentage / 100)
        const formattedDiscountedComparePrice = new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: 'CHF'
        }).format(discountedComparePrice / 100)
        
        variant.setAttribute('data-variant-compare-price-discounted', formattedDiscountedComparePrice)
      }
    })
    
    // Process product card variants
    productCardVariants.forEach((variant) => {
      const rawPrice = parseFloat(variant.getAttribute('data-variant-price-raw'))
      const rawComparePrice = parseFloat(variant.getAttribute('data-variant-compare-price-raw'))
      
      
      if (rawPrice && !isNaN(discountPercentage) && discountPercentage > 0) {
        const discountedPrice = rawPrice * (1 - discountPercentage / 100)
        const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: 'CHF'
        }).format(discountedPrice / 100)
        
        variant.setAttribute('data-variant-price-discounted', formattedDiscountedPrice)
      }
      
      if (rawComparePrice && rawComparePrice > 0 && !isNaN(discountPercentage) && discountPercentage > 0) {
        const discountedComparePrice = rawComparePrice * (1 - discountPercentage / 100)
        const formattedDiscountedComparePrice = new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: 'CHF'
        }).format(discountedComparePrice / 100)
        
        variant.setAttribute('data-variant-compare-price-discounted', formattedDiscountedComparePrice)
      }
    })
    
    // Apply discount to the currently selected/first variant on page load
    const activeVariant = document.querySelector('.variant__container.active-variant') || 
                         document.querySelector('.variant__container:first-child')
    
    if (activeVariant && discountPercentage > 0) {
      const rawPrice = parseFloat(activeVariant.getAttribute('data-variant-original-price'))
      if (rawPrice) {
        const discountedPrice = rawPrice * (1 - discountPercentage / 100)
        const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: 'CHF'
        }).format(discountedPrice / 100)
        
        // Update the main product price display
        const discountedPriceElement = document.querySelector('.product__price--discounted')
        const regularPriceElement = document.querySelector('.product__price--regular')
        
        if (discountedPriceElement) {
          discountedPriceElement.textContent = formattedDiscountedPrice
          discountedPriceElement.style.display = 'inline'
        }
        
        if (regularPriceElement) {
          regularPriceElement.classList.add('discount-active')
        }
        
      }
    }
    
    // Handle products with single/default variants (no variant containers)
    // Main product pages
    const isMainProductPage = document.querySelector('.product-container')
    const hasVariants = document.querySelector('.variant__container')
    
    if (isMainProductPage && !hasVariants && discountPercentage > 0) {
      const regularPriceElement = document.querySelector('.product__price--regular')
      const discountedPriceElement = document.querySelector('.product__price--discounted')
      
      if (regularPriceElement && discountedPriceElement) {
        // Get original price from either element that has it
        let originalPriceValue = parseFloat(discountedPriceElement.getAttribute('data-original-price'))
        if (!originalPriceValue) {
          originalPriceValue = parseFloat(regularPriceElement.getAttribute('data-original-price'))
        }
        
        
        if (originalPriceValue) {
          const discountedPrice = originalPriceValue * (1 - discountPercentage / 100)
          const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF'
          }).format(discountedPrice / 100)
          
          // Show discounted price as main price
          discountedPriceElement.textContent = formattedDiscountedPrice
          discountedPriceElement.style.display = 'inline'
          
          // Mark regular price as crossed out
          regularPriceElement.classList.add('discount-active')
        } 
      } else {
        console.warn('Missing price elements for single variant product:', {
          regularPriceElement: !!regularPriceElement,
          discountedPriceElement: !!discountedPriceElement
        })
      }
    }
    
    // Handle product cards with single variants (no variant containers)
    const productCards = document.querySelectorAll('.product-card')
    productCards.forEach(card => {
      const hasCardVariants = card.querySelector('.product-card__variant')
      const discountedPriceElement = card.querySelector('.product-card__price--discounted')
      const regularPriceElement = card.querySelector('.product-card__price--regular')
      
      if (!hasCardVariants && discountedPriceElement && regularPriceElement && discountPercentage > 0) {
        // Get original price from the data attribute
        const originalPriceValue = parseFloat(discountedPriceElement.getAttribute('data-original-price'))
        
        if (originalPriceValue) {
          const discountedPrice = originalPriceValue * (1 - discountPercentage / 100)
          const formattedDiscountedPrice = new Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF'
          }).format(discountedPrice / 100)
          
          // Show discounted price
          discountedPriceElement.textContent = formattedDiscountedPrice
          discountedPriceElement.style.display = 'inline'
          
          // Mark regular price as crossed out
          regularPriceElement.classList.add('discount-active')
          
        }
      }
    })
  } else {
    // Discount is not active - hide discount elements and restore normal pricing
    productCardActiveDiscount.forEach((item)=>{
      item.style.display = "none"
    })

    // Hide main product discount badges
    productMainActiveDiscount.forEach((item)=>{
      item.style.display = "none"
    })

    variantActiveDiscounts.forEach((item)=>{
      item.style.display = "none"
    })

    productCardActiveDiscountPrice.forEach((item)=>{
      item.style.display = "none"
      
      // Remove discount styling from regular prices
      const regularPrice = item.parentElement.querySelector('.product-card__price--regular')
      if (regularPrice) {
        regularPrice.classList.remove('discount-active')
      }
      
      // Remove discount styling from compare prices
      const regularComparePrice = item.parentElement.querySelector('.product-card__compare-price--regular')
      if (regularComparePrice) {
        regularComparePrice.classList.remove('discount-active')
      }
    })

    // Hide main product discounted prices
    productMainDiscountedPrice.forEach((item)=>{
      item.style.display = "none"
      
      // Remove discount styling from regular prices
      const regularPrice = item.parentElement.querySelector('.product__price--regular')
      if (regularPrice) {
        regularPrice.classList.remove('discount-active')
      }
      
      // Remove discount styling from compare prices
      const regularComparePrice = item.parentElement.querySelector('.product__compare-at-price--regular')
      if (regularComparePrice) {
        regularComparePrice.classList.remove('discount-active')
      }
    })

    // Remove discount data attributes from variants
    const mainProductVariants = document.querySelectorAll('.variant__container')
    const productCardVariants = document.querySelectorAll('.product-card__variant')
    
    mainProductVariants.forEach((variant) => {
      variant.removeAttribute('data-variant-price-discounted')
      variant.removeAttribute('data-variant-compare-price-discounted')
    })
    
    productCardVariants.forEach((variant) => {
      variant.removeAttribute('data-variant-price-discounted')
      variant.removeAttribute('data-variant-compare-price-discounted')
    })
    
    // Handle single variant products cleanup - Main product pages
    const isMainProductPage = document.querySelector('.product-container')
    const hasVariants = document.querySelector('.variant__container')
    
    if (isMainProductPage && !hasVariants) {
      const regularPriceElement = document.querySelector('.product__price--regular')
      const discountedPriceElement = document.querySelector('.product__price--discounted')
      
      if (regularPriceElement) {
        regularPriceElement.classList.remove('discount-active')
      }
      
      if (discountedPriceElement) {
        discountedPriceElement.style.display = 'none'
      }
    }
    
    // Handle single variant products cleanup - Product cards
    const productCards = document.querySelectorAll('.product-card')
    productCards.forEach(card => {
      const hasCardVariants = card.querySelector('.product-card__variant')
      
      if (!hasCardVariants) {
        const regularPriceElement = card.querySelector('.product-card__price--regular')
        const discountedPriceElement = card.querySelector('.product-card__price--discounted')
        
        if (regularPriceElement) {
          regularPriceElement.classList.remove('discount-active')
        }
        
        if (discountedPriceElement) {
          discountedPriceElement.style.display = 'none'
        }
      }
    })
  } 
} else {
  // window.dates is not available or discount is disabled - ensure normal pricing
  productCardActiveDiscount.forEach((item)=>{
    item.style.display = "none"
  })

  // Hide main product discount badges
  productMainActiveDiscount.forEach((item)=>{
    item.style.display = "none"
  })

  variantActiveDiscounts.forEach((item)=>{
    item.style.display = "none"
  })

  productCardActiveDiscountPrice.forEach((item)=>{
    item.style.display = "none"
    
    // Remove discount styling from regular prices
    const regularPrice = item.parentElement.querySelector('.product-card__price--regular')
    if (regularPrice) {
      regularPrice.classList.remove('discount-active')
    }
    
    // Remove discount styling from compare prices
    const regularComparePrice = item.parentElement.querySelector('.product-card__compare-price--regular')
    if (regularComparePrice) {
      regularComparePrice.classList.remove('discount-active')
    }
  })

  // Hide main product discounted prices
  productMainDiscountedPrice.forEach((item)=>{
    item.style.display = "none"
    
    // Remove discount styling from regular prices
    const regularPrice = item.parentElement.querySelector('.product__price--regular')
    if (regularPrice) {
      regularPrice.classList.remove('discount-active')
    }
    
    // Remove discount styling from compare prices
    const regularComparePrice = item.parentElement.querySelector('.product__compare-at-price--regular')
    if (regularComparePrice) {
      regularComparePrice.classList.remove('discount-active')
    }
  })

  // Remove discount data attributes from variants
  const mainProductVariants = document.querySelectorAll('.variant__container')
  const productCardVariants = document.querySelectorAll('.product-card__variant')
  
  mainProductVariants.forEach((variant) => {
    variant.removeAttribute('data-variant-price-discounted')
    variant.removeAttribute('data-variant-compare-price-discounted')
  })
  
  productCardVariants.forEach((variant) => {
    variant.removeAttribute('data-variant-price-discounted')
    variant.removeAttribute('data-variant-compare-price-discounted')
  })
  
  // Handle single variant products cleanup - Main product pages
  const isMainProductPage = document.querySelector('.product-container')
  const hasVariants = document.querySelector('.variant__container')
  
  if (isMainProductPage && !hasVariants) {
    const regularPriceElement = document.querySelector('.product__price--regular')
    const discountedPriceElement = document.querySelector('.product__price--discounted')
    
    if (regularPriceElement) {
      regularPriceElement.classList.remove('discount-active')
    }
    
    if (discountedPriceElement) {
      discountedPriceElement.style.display = 'none'
    }
  }
  
  // Handle single variant products cleanup - Product cards
  const productCards = document.querySelectorAll('.product-card')
  productCards.forEach(card => {
    const hasCardVariants = card.querySelector('.product-card__variant')
    
    if (!hasCardVariants) {
      const regularPriceElement = card.querySelector('.product-card__price--regular')
      const discountedPriceElement = card.querySelector('.product-card__price--discounted')
      
      if (regularPriceElement) {
        regularPriceElement.classList.remove('discount-active')
      }
      
      if (discountedPriceElement) {
        discountedPriceElement.style.display = 'none'
      }
    }
  })
}